export default __webpack_public_path__ + "static/media/plans.8e63d4af.svg";